import React, { Component } from 'react';
import __ from 'lodash';
import { connect } from 'react-redux';
import { cekCookies } from '../../../../../actions';
import { CONFIG } from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';
import Loader from '../../../../Loader';
import LoaderModal from '../../../../modal/LoaderModal';
import style from './style.css';
import logo_exam from '../../homework/images/banner_homework_report_detail.png';
import $ from 'jquery';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';


const dataSet = [];
const multiDataSet = [
    {
        columns: ["Name", "Salary", "Sex"],
        data: [
            ["Johnson", 30000, "Male"],
            ["Monika", 355000, "Female"],
            ["Konstantina", 20000, "Female"],
            ["John", 250000, "Male"],
            ["Josef", 450500, "Male"],
        ]
    },
    {
        xSteps: 1, // Will start putting cell with 1 empty cell on left most
        ySteps: 5, //will put space of 5 rows,
        columns: ["Name", "Department"],
        data: [
            ["Johnson", "Finance"],
            ["Monika", "IT"],
            ["Konstantina", "IT Billing"],
            ["John", "HR"],
            ["Josef", "Testing"],
        ]
    }
];

const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';

class RekapExam extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rekapTotal: [],
            rekapMapel: [],
            listMapel: [],
            listData: [],
            xlsData: [],
            jadwal: '',
            sekolah: '',
            kelasP: '',
            isLoading: false,
            isFetching: false
        }
    }

    async componentDidMount() {
        this.setState({
            isLoading: true
        });
        await this.props.cekCookies();
        if (!__.isEmpty(this.props.account)) {
            this.fetchRekap();
        }
        this.fetchRekap();

        // this.setState({ isFetching: false });
    }

    fetchRekap = async () => {
        this.setState({
            isLoading: true
        });
        const response = await accountManagement.post(CONFIG.REKAP_EXAM, {
            ['idJadwal']: this.props.match.params.idJadwal,
            ['idProfil']: this.props.match.params.idProfil,
            ['idKelasParalel']: this.props.match.params.idKelasParalel,
            ['tahunAjaran']: this.props.match.params.ta1 + '/' + this.props.match.params.ta2
        }).catch(function (error) {
            console.error(error)
        });

        if (response) {
            if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    rekapTotal: response.data.data.skorSiswaTotal,
                    rekapMapel: response.data.data.skorSiswaMapel,
                    listMapel: response.data.data.listMapel,
                    jadwal: response.data.data.jadwal,
                    sekolah: response.data.data.sekolah,
                    kelasP: response.data.data.kelasParalel
                })
            }
            this.setState({
                isLoading: false
            });
        }
    }

    renderSkor = (idSiswa, idSubProfil) => {
        let skor = 0;
        this.state.rekapMapel.map(k => {
            if (k.idSiswa === idSiswa && k.idSubProfil == idSubProfil) {
                skor = k.skor;
            }
        })
        return skor;
    }

    exportToXls = () => {
        // find headers
        var headers = []
        $('#rekap tr th').each(function (i) {
            headers.push($(this).text())
        })
        // result array
        var array = [];
        $('#rekap tr').each(function (i) {
            // declare object variable but dont set it's value
            // unless there are objects to find
            var rowObj
            $(this).find('td').each(function (i) {
                if (!rowObj) rowObj = {}

                // use the header we found earlier
                rowObj[headers[i]] = $(this).text()

            });
            // if we found active objects, rowObje will be defined
            if (rowObj) array.push(rowObj)
        });
        // console.log(array)

        const ws = XLSX.utils.json_to_sheet(array);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, this.state.jadwal + '-' + this.state.kelasP + fileExtension);
    }

    render() {
        require('../../homework/homeworkReport.css');

        return (
            <div className="containerFluid" style={{ marginTop: '20px' }}>
                {this.state.isLoading ? <Loader /> :
                    <div className="cardLine">
                        <div className="pnl-header">
                            <div className="card-page">
                                <span style={{
                                    fontSize: '26px',
                                    color: '#FFF',
                                    fontWeight: 500,
                                    fontFamily: 'lucida grande'
                                }}>01</span>
                            </div>
                            <div className="pnl-date">
                                https://eduprime.co.id
                            </div>
                        </div>
                        <div className="header-first-page" style={{ padding: '0px', marginBottom: '30px' }}>
                            <div className="text-header" style={{ padding: '0px' }}>
                                <div className="title-header2" style={{ color: '#015E56' }}>SEBARAN PILIHAN JAWABAN SISWA</div>
                                <div className="label-sub-tit">
                                    <span className="sub-title-header" style={{ color: '#FFF' }}>REPORT</span>
                                </div>
                            </div>
                            <div className="image-header">
                                <div className="logo-edu">
                                    <img src="https://eduprime.co.id/static/images/LOGO_EDUPRIME_2.png" width={"100%"} />
                                </div>
                                <div className="logo-an">
                                    <img src="/assets/image/LOGO_AN_2.png" width={"100%"} style={{ height: '33px', width: '148px' }} />
                                </div>
                            </div>
                        </div>

                        <div style={{width: '100%', display:'flex', justifyContent: 'space-between'}}>
                            <div className="col-md-4 header-title-text left">
                                NAMA JADWAL {this.state.jadwal}
                            </div>

                            <div className="col-md-4 header-title-text right">
                                KELAS {this.state.kelasP}, {this.state.sekolah}
                            </div>
                        </div>

                        <table className="table table-custom" id="rekap">
                            <thead>
                                <tr>
                                    <th className="th-title v-align-center" rowSpan="2" width="10px" scope="col">No.</th>
                                    <th className="th-title v-align-center" rowSpan="2" width="20%" scope="col">Nama Siswa</th>
                                    {this.state.listMapel.map((mapel, i) =>
                                        <th key={i} className="th-title v-align-center" rowSpan="2" scope="col">{mapel.nama}</th>
                                    )}
                                    <th className="th-title v-align-center" rowSpan="2" scope="col">Total Nilai</th>
                                    <th className="th-title v-align-center" rowSpan="2" scope="col">Total Waktu</th>
                                </tr>
                            </thead>

                            <tbody>
                                {this.state.rekapTotal.map((a, i) =>
                                    <tr key={a.idSiswa}>
                                        <td>{i + 1}</td>
                                        <td>{a.namaSiswa}</td>
                                        {this.state.listMapel.map((m, j) =>
                                            <td align="center" key={j}>
                                                {this.renderSkor(a.idSiswa, m.idSubProfilCbt)}
                                            </td>
                                        )}
                                        <td align="center">{a.totalSkor}</td>
                                        <td align="center">{a.totalWaktu}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                }
                <div className="fixed_button">
                    <button className="btn btn-outline-dark btn133w pull-right" style={{ marginRight: '1em' }} onClick={(e) => this.exportToXls()}>Export Excel</button>
                </div>
            </div>
        );
    }
    loading = () => {
        if (this.state.isLoading) {
            return (
                <Loader />
            )
        }
    }
}

const mapStateToProps = (state) => {
    return {
        account: state.account
    };
}

export default connect(mapStateToProps, { cekCookies })(RekapExam);